// 钻石销售信息
<template>
    <div class="main mainds">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">钻石信息</span>
                    </div>
                    <div class="search-content mar_b">
                        <el-form :inline="true" label-width="100px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-col :span="14">
                            <el-form-item prop="shape" label="形状：" label-width="60px">
                                <el-checkbox-group v-model="checkboxGroup1" size="small" @change="checkboxChange1">
                                    <el-tooltip class="item" effect="light" content="圆形" placement="top-start">
                                        <el-checkbox-button label="圆形"><span class="el-icon-round"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="公主方" placement="top-start">
                                        <el-checkbox-button label="公主方"><span class="el-icon-princess"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="雷迪恩" placement="top-start">
                                        <el-checkbox-button label="雷迪恩"><span class="el-icon-radiant"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="阿斯切" placement="top-start">
                                        <el-checkbox-button label="阿斯切"><span class="el-icon-asscher"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="马眼" placement="top-start">
                                        <el-checkbox-button label="马眼"><span class="el-icon-marquise"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="椭圆形" placement="top-start">
                                        <el-checkbox-button label="椭圆形"><span class="el-icon-oval"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="祖母绿" placement="top-start">
                                        <el-checkbox-button label="祖母绿"><span class="el-icon-emerald"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="梨形" placement="top-start">
                                        <el-checkbox-button label="梨形"><span class="el-icon-pear1"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="心形" placement="top-start">
                                        <el-checkbox-button label="心形"><span class="el-icon-heart"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="垫形" placement="top-start">
                                        <el-checkbox-button label="垫形"><span class="el-icon-cushion"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="其他" placement="top-start">
                                        <el-checkbox-button label="其他"><span class="el-icon-others"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="三角形" placement="top-start">
                                        <el-checkbox-button label="三角形"><span class="el-icon-triangle"/></el-checkbox-button>
                                    </el-tooltip>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="col" label="颜色：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup2" size="small" @change="checkboxChange2">
                                    <el-checkbox-button v-for="color in colorlist" :label="color" :key="color">{{color}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cla" label="净度：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup3" size="small" @change="checkboxChange3">
                                    <el-checkbox-button v-for="cla in clalist" :label="cla" :key="cla">{{cla}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cut" label="切工：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup4" size="small" @change="checkboxChange4">
                                    <el-checkbox-button v-for="cut in cutlist" :label="cut" :key="cut">{{cut}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3EX" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3exn" size="small">3EX-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="pol" label="抛光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup5" size="small" @change="checkboxChange5">
                                    <el-checkbox-button v-for="pol in pollist" :label="pol" :key="pol">{{pol}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="EX" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="selectexn" size="small">EX-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="sym" label="对称：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup6" size="small" @change="checkboxChange6">
                                    <el-checkbox-button v-for="sym in pollist" :label="sym" :key="sym">{{sym}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="VG" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="selectvgn" size="small">VG-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="fl" label="荧光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup7" size="small" @change="checkboxChange7">
                                    <el-checkbox-button v-for="fl in fllist" :label="fl" :key="fl">{{fl}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right;margin-top:-15px;margin-right:120px">
                                <el-button type="primary" @click="selectDiamondInfoList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item><br>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item prop="ct" label="重量：" label-width="90px">
                                <el-select v-model="query.ct" placeholder="请选择" clearable
                                        @blur="ctSelect" @change="ctChange" filterable allow-create style="width:180px">
                                    <el-option label="0.30-0.39" value="3"></el-option>
                                    <el-option label="0.40-0.49" value="4"></el-option>
                                    <el-option label="0.50-0.69" value="5"></el-option>
                                    <el-option label="0.70-0.89" value="7"></el-option>
                                    <el-option label="1.00-1.49" value="10"></el-option>
                                    <el-option label="1.50-1.99" value="15"></el-option>
                                </el-select>
                                <el-input v-model="query.ct3" placeholder="请输入" style="width:80px" @change="ctChange3"></el-input>
                                -<el-input v-model="query.ct4" placeholder="请输入" style="width:80px" @change="ctChange4"></el-input>
                            </el-form-item><br>
                            <el-form-item prop="cert_no" label="证书号：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.cert_no" placeholder="请输入" style="width:180px"></el-input>
                            </el-form-item><br>
                            <el-form-item prop="place" label="地点：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup12" size="small" @change="checkboxChange12">
                                    <el-checkbox-button v-for="item in placeList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                                <!--<el-select v-model="query.place" placeholder="请选择" clearable style="width:220px">
                                    <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>-->
                            </el-form-item><br>
                            <el-form-item prop="cert" label="证书：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup8" size="small" @change="checkboxChange8">
                                    <el-checkbox-button v-for="cert in certlist" :label="cert" :key="cert">{{cert}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="rate" label="汇率：" label-width="90px" style="margin-top:-15px">
                                {{ ratevalue }}
                            </el-form-item><br>
                            </el-col>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">获取证书号</el-button>
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="selectAllList" size="small">导出全部</el-button>
                        <el-button type="primary" @click="savaAllOrderInfo" :disabled="isAble" size="small">批量下单</el-button>
                        <el-button type="primary" @click="savaAllShopInfo" :disabled="isAble" size="small">加入购物车</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="block tar mar_t">
                        <!--分页-->
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}}； 总克重：{{ ct_total }}； 总售价${{ sale_usd_total }},￥{{ sale_price_total }} ；</span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[10, 20, 50, 200, 500]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="text e-info auto-table">
                        <el-table :data="diamondInfoList" stripe
                            @selection-change="selectionLineChangeHandle"
                            ref="refTable" size="mini" @sort-change="sortTableFun"
                            :header-cell-style="{background:'#eef1f6',color:'black',fontSize:'10px',padding:'0',margin:'0'}" 
                            :row-style="{height:'10px',color:'black',fontSize:'11px',padding:'0 0',margin:'0'}">
                            <el-table-column type="selection" align="center" width="50"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="image_link" label="图片" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-image fit="contain" style="height:20px" v-if="scope.row.image_link !== ''" lazy
                                        :src="scope.row.image_link" :preview-src-list="[scope.row.image_link]">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" min-width="6%" prop="place" label="地点"></el-table-column>
                            <!--<el-table-column align="center" width="80" prop="inv_status" label="库存状态"></el-table-column>-->
                            <el-table-column align="center" min-width="9%" prop="sale_status" label="订单状态"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="shape" label="形状"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="ct" label="重量" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="col" label="颜色"></el-table-column>
                            <el-table-column align="center" min-width="7%" prop="cla" label="净度"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="cut" label="切工"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="pol" label="抛光"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="sym" label="对称"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="fl" label="荧光"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="cert" label="证书"></el-table-column>
                            <el-table-column align="center" min-width="13%" prop="cert_no" label="证书号">
                                <!--<template slot-scope="scope">
                                    <el-popover trigger="click" placement="top">
                                    <p>证书号: {{ scope.row.cert_no }}</p>
                                    <p>形状: {{ scope.row.shape }}</p>
                                    <p>重量: {{ scope.row.ct }}</p>
                                    <p>颜色: {{ scope.row.col }}</p>
                                    <p>净度: {{ scope.row.cla }}</p>
                                    <p>切工: {{ scope.row.cut }}</p>
                                    <p>抛光: {{ scope.row.pol }}</p>
                                    <p>对称: {{ scope.row.sym }}</p>
                                    <p>荧光: {{ scope.row.fl }}</p>
                                        <div slot="reference" class="name-wrapper">
                                            <el-tag size="medium">{{ scope.row.cert_no }}</el-tag>
                                        </div>
                                    </el-popover>
                                </template>-->
                            </el-table-column>
                            <el-table-column align="center" min-width="8%" prop="sale_rap" label="Rap"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="new_dis" label="折扣" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="sale_usd" label="USD"></el-table-column>
                            <el-table-column align="center" min-width="12%" prop="sale_price" label="RMB" :render-header="renderHeader" sortable></el-table-column>
                            <!--<el-table-column align="center" min-width="8%" prop="sale_rate" label="销售汇率"></el-table-column>-->
                            <el-table-column align="center" min-width="16%" prop="meas" label="尺寸"></el-table-column>
                            <el-table-column align="center" min-width="7%" prop="table1" label="台面"></el-table-column>
                            <el-table-column align="center" min-width="7%" prop="depth" label="全深"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="ratio" label="比例"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="ec" label="EC"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="bt" label="BT"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="bs" label="BS"></el-table-column>
                            <!--<el-table-column align="center" width="100" prop="data_date" label="数据日期"></el-table-column>-->
                            <!--<el-table-column align="center" width="100" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" @click="savaShopInfo(scope.row)" 
                                    size="mini">选购</el-button>
                                </template>
                            </el-table-column>-->
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    const cityOptions = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-N', 'O-Z'];
    export default {
        data() {
            return {
                isAble: true,
                isdisabled: false,
                dialogTableVisible: false,
                checkboxGroup1: [],
                checkboxGroup2: [],
                checkboxGroup3: [],
                checkboxGroup4: [],
                checkboxGroup5: [],
                checkboxGroup6: [],
                checkboxGroup7: [],
                checkboxGroup8: [],
                checkboxGroup9: [],
                checkboxGroup10: [],
                checkboxGroup11: [],
                checkboxGroup12: [],
                shapeList1: [{'value':'round'},{'value':'princess'},{'value':'radiant'}
                            ,{'value':'asscher'},{'value':'marquise'},{'value':'oval'}
                            ,{'value':'emerald'},{'value':'pear'},{'value':'heart'}
                            ,{'value':'cushion'},{'value':'others'},{'value':'triangle'}],
                shapeList: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList: [{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            ,{'value':'HRD'},{'value':'None'},{'value':'Other'}],
                inv_statusList: [{'value':'在库'},{'value':'不在库'}],
                sale_statusList: [{'value':'在售'},{'value':'保留'},{'value':'借货'}
                            ,{'value':'全款借货'},{'value':'确认销售'},{'value':'已完成'}],
                colorlist: cityOptions,
                clalist: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3','I1','I2'],
                cutlist: ['EX', 'VG', 'GD', 'FR', 'PR', 'NN'],
                pollist: ['EX', 'VG', 'GD', 'FR', 'PR'],
                fllist: ['N', 'VSL', 'F', 'M', 'S', 'VS'],
                certlist: ['GIA', 'NGTC', 'IGI', 'HRD', 'None', 'Other'],
                inv_status: '',
                addDataForm: {},
                addDataForm2: {},
                addDataForm3: {
                    'sale_status': '1',
                    'tiaodian1': '1',
                    'date_long': '24h',
                },
                addDataForm4: {},
                addDataForm5: {},
                addDataForm6: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                sale_priceList: [],
                idList: [],
                idStr: '',
                cert_noStr: '',
                sale_priceStr: '',
                diamondInfoList: [],
                diamondAllInfoList: {},
                diamondCZInfoList: {},
                diamondRapnetInfoList: {},
                imgViewerVisible:false,
                ct_total: 0,
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                ratevalue: '',
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                },
                column: 'sale_price',
                order: 'asc',
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 200,
                    total: 0
                },
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectDiamondInfoList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectDiamondInfoList();
            },
            // shape 形状
            checkboxChange1(val) {
                this.query.shape = val.join();
                console.log(this.query.shape);
            },
            // 颜色
            checkboxChange2(val) {
                this.query.col = val.join();
                console.log(this.query.col);
            },
            // 净度
            checkboxChange3(val) {
                this.query.cla = val.join();
                console.log(this.query.col);
            },
            // 切工
            checkboxChange4(val) {
                this.query.cut = val.join();
                console.log(this.query.cut);
            },
            // 抛光
            checkboxChange5(val) {
                this.query.pol = val.join();
                console.log(this.query.pol);
            },
            // 对称
            checkboxChange6(val) {
                this.query.sym = val.join();
                console.log(this.query.sym);
            },
            // 荧光
            checkboxChange7(val) {
                this.query.fl = val.join();
                console.log(this.query.fl);
            },
            // 证书
            checkboxChange8(val) {
                this.query.cert = val.join();
                console.log(this.query.cert);
            },
            // 地点
            checkboxChange12(val) {
                this.query.place = val.join();
                console.log(this.query.place);
            },
            // 联动赋值重量
            ctChange(val) {
                if(val == 3) {
                    this.$set(this.query,'ct1','0.30');
                    this.$set(this.query,'ct2','0.39');
                }else if(val == 4) {
                    this.$set(this.query,'ct1','0.40');
                    this.$set(this.query,'ct2','0.49');
                }else if(val == 5) {
                    this.$set(this.query,'ct1','0.50');
                    this.$set(this.query,'ct2','0.69');
                }else if(val == 7) {
                    this.$set(this.query,'ct1','0.70');
                    this.$set(this.query,'ct2','0.89');
                }else if(val == 10) {
                    this.$set(this.query,'ct1','1.00');
                    this.$set(this.query,'ct2','1.49');
                }else if(val == 15) {
                    this.$set(this.query,'ct1','1.50');
                    this.$set(this.query,'ct2','1.99');
                }
            },
            // 手动输入重量
            ctSelect(e) {
                let value = e.target.value;
                if(value) {
                    console.log(value)
                    if(value.includes('-')){
                        this.$nextTick(()=> {
                            this.$set(this.query,'ct',value);
                        })
                        // this.query.ct = value;
                        let valArr = value.split('-');
                        this.$set(this.query,'ct1',valArr[0]);
                        this.$set(this.query,'ct2',valArr[1]);
                        console.log(this.query.ct1);
                        console.log(this.query.ct2);
                    }
                }
            },
            // 手动输入重量2
            ctChange3(value) {
                if(value) {
                    this.$set(this.query,'ct','');
                    console.log(value)
                    this.$set(this.query,'ct1',value);
                    console.log(this.query.ct1);
                }
            },
            ctChange4(value) {
                if(value) {
                    console.log(value)
                    this.$set(this.query,'ct2',value);
                    console.log(this.query.ct2);
                }
            },
            // 3EXN
            select3exn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX'];
                this.checkboxGroup6 = ['EX'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX';
                this.query.sym = 'EX';
                this.query.fl = 'N';
            },
            // EXN
            selectexn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // VGN
            selectvgn() {
                this.checkboxGroup4 = ['VG'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'VG';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // 选择器选择数据，加工数据证书号、统计数据
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 计算总销售额
                let sale_rap1 = 0;
                let sale_usd1 = 0;
                let sale_price1 = 0;
                let ct1 = 0;
                for(let a = 0; a < this.data_len; a++) {
                    console.log(val[a].sale_price);
                    console.log(val[a].ct);
                    // 进货价
                    sale_rap1 += val[a].sale_rap;
                    // 销售价格
                    sale_usd1 += val[a].sale_usd;
                    sale_price1 += val[a].sale_price;
                    // 重量
                    ct1 += parseFloat(val[a].ct);
                }
                // 进货价
                this.sale_rap_total = sale_rap1.toFixed(2);
                // 销售价格
                this.sale_usd_total = sale_usd1.toFixed(2);
                this.sale_price_total = sale_price1.toFixed(2);
                // 总重量
                this.ct_total = ct1.toFixed(2);
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                this.sale_priceList = val.map((item) => item.sale_price);
                //数据选中后，显示按钮
                if(this.certnoList.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                console.log(this.certnoStr)
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 前端处理 选中数据导出
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','地点', '状态', '形状', '重量', '颜色'
                            , '净度', '切工', '抛光', '对称', '荧光', '证书'
                            , '销售rap', '销售折扣', '销售美金', '售价'
                            , '尺寸', '台面', '全深', '比例', '数据日期']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd' , 'sale_price' 
                            ,'meas', 'table1', 'depth', 'ratio', 'data_date' ]
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '钻石信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','地点', '状态', '形状', '重量', '颜色'
                            , '净度', '切工', '抛光', '对称', '荧光', '证书'
                            , '销售rap', '销售折扣', '销售美金', '售价'
                            , '尺寸', '台面', '全深', '比例', '数据日期']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd' , 'sale_price' 
                            ,'meas', 'table1', 'depth', 'ratio', 'data_date' ]
                    const list = this.diamondAllInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '全部钻石信息')
                })
            },
            // 查询全部数据用于导出
            selectAllList() {
                let _this = this;
                util.publicget('/shopping/getDaimondAllList2ByCondition', {
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondAllInfoList = res.obj;
                            _this.exportAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 加载分页数据信息
            selectDiamondInfoList() {
                let _this = this;
                let place = 'SZ';
                util.publicget('/shopping/queryDaimondListPageModel', {
                    shape: _this.query.shape,
                    col: _this.query.col,
                    cla: _this.query.cla,
                    cut: _this.query.cut,
                    pol: _this.query.pol,
                    sym: _this.query.sym,
                    fl: _this.query.fl,
                    place: place,
                    cert: _this.query.cert,
                    cert_no: _this.query.cert_no,
                    greaterEqualsCt: _this.query.ct1,
                    lessCt: _this.query.ct2,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows,
                    order: _this.order,
                    column: _this.column
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.diamondInfoList = res.obj;
                        _this.certnoList = res.obj.map((item) => item.cert_no + '\n');
                        _this.idList = res.obj.map((item) => item.id);
                    } else {
                        _this.errorMsg('操作失败!');
                    }
                });
            },
            // 加入购物车
            savaShopInfo(rows) {
                let _this = this;
                _this.idStr = rows.id;
                _this.cert_noStr = rows.cert_no;
                _this.sale_priceStr = rows.sale_price;
                util.publicget('/shopping/savaShopInfo', {
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr,
                    cert_no: _this.cert_noStr,
                    sale_price: _this.sale_priceStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 加入购物车
            savaShopInfoSelect() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                _this.sale_priceStr = _this.sale_priceList.join(',');
                util.publicget('/shopping/savaShopInfo', {
                    user: sessionStorage.getItem('userName'),
                    sale_price: _this.sale_priceStr,
                    id: _this.idStr,
                    cert_no: _this.cert_noStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.idStr = '';
                        _this.cert_noStr = '';
                        _this.sale_priceStr = '';
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 查询数据字典 地点
            selectPlaceDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '地点'
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.placeList = res.obj;
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // 批量加入购物车
            savaAllShopInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/shopping/savaShopInfo', {
                    user: sessionStorage.getItem('userName'),
                    id: idStr,
                    cert_no: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 客户批量下单
            savaAllOrderInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/shopping/savaOrderInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: idStr,
                    cert_no: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 查询数据字典 汇率
            selectRateDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '汇率'
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.ratevalue = res.obj[0].value;
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.checkboxGroup1 = [];
                this.checkboxGroup2 = [];
                this.checkboxGroup3 = [];
                this.checkboxGroup4 = [];
                this.checkboxGroup5 = [];
                this.checkboxGroup6 = [];
                this.checkboxGroup7 = [];
                this.checkboxGroup8 = [];
                this.checkboxGroup9 = [];
                this.checkboxGroup11= [];
                this.checkboxGroup12 = [];
                this.query = [];
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            // 根据rmb排序
            sortTableFun (column) {
                this.column = column.prop;
                if (column.prop) {
                    if (column.order == 'ascending') {
                        this.order = 'asc'
                    }else if (column.order == 'descending') {
                        this.order = 'desc'
                    }
                    this.selectDiamondInfoList();
                }
            },
            renderHeader (h, {column, $index }) {
                if (column.order == 'ascending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-up'
                            })
                        ]
                    )
                }else if (column.order == 'descending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-down'
                            })
                        ]
                    )
                } else {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort'
                            })
                        ]
                    )
                }
            }
        },
        mounted() {
            this.selectDiamondInfoList();
            this.selectPlaceDictList();
            this.selectRateDictList();
            // console.log(this.url);
        }
    };
</script>

<style lang="scss" scoped>
    /**手机屏幕展示 */
    @media screen and (max-width: 748px){
        .mainds {
            position: relative;
            float: left;
            height: 500px;
        }
        .mainds {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.50);
            transform: scale(0.50);
            transform-origin: left top;
        }
    }
    /**奇偶行变色 */
    .el-table__row--striped td {
        background-color: #eaf3fb !important;
    }
    /** 修改表格行高 */
    .el-table .el-table__cell{
        padding: 3px 0px
    }
    .el-icon-round {
        background:url('../../assets/images/cut/round.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-princess {
        background:url('../../assets/images/cut/princess.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-radiant {
        background:url('../../assets/images/cut/radiant.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-asscher {
        background:url('../../assets/images/cut/asscher.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-marquise {
        background:url('../../assets/images/cut/marquise.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-oval {
        background:url('../../assets/images/cut/oval.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-emerald {
        background:url('../../assets/images/cut/emerald.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-pear1 {
        background:url('../../assets/images/cut/pear1.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-heart {
        background:url('../../assets/images/cut/heart.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-cushion {
        background:url('../../assets/images/cut/cushion.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-others {
        background:url('../../assets/images/cut/others.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-triangle {
        background:url('../../assets/images/cut/triangle.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-dialog{
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/shop/diamondShopList.vue